import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() showSpinner: boolean;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/spinner/spinner.component.ts